import styled from 'styled-components';
import {SectionTitle} from './Layout';
import {useTranslation} from 'react-i18next';
import ProjectCard from './ProjectCard';

type Props = {
  list: HRCustomer['projects'];
  onClick: (str: string) => void;
};

const SectionProjects = ({list, onClick}: Props) => {
  const {t} = useTranslation();

  return (
    <Container>
      <Inner>
        <SectionTitle>{t('dashboard.your-projects')}</SectionTitle>
        <List>
          {list.map((p, i) => (
            <ProjectCard key={i} {...p} onClick={onClick} />
          ))}
        </List>
      </Inner>
    </Container>
  );
};

export default SectionProjects;

const Container = styled.div`
  background-color: ${(p) => p.theme.colors.orange100};
  margin: 70px auto;
`;

const Inner = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 70px 20px;
`;

const List = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 40px;
  flex-wrap: wrap;
`;
